import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/At.es.js";
const t = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...e, weights: m }));
t.displayName = "AtIcon";
const n = t;
export {
  n as At,
  t as AtIcon
};
